import React, {Fragment} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import {formatNumber, formatDate} from 'admin/lib/format'
import useModal from '../../hooks/useModal'

const InvoiceRow = ({invoice, onClick}) => {
  const rowStyle = {}
  if (invoice.state === 'draft') rowStyle.opacity = '25%'
  return (
    <tr onClick={onClick} style={rowStyle}>
      <td>{formatDate(invoice.date)}</td>
      <td>
        {invoice.xeroLink && (
          <span className='tag is-small has-text-white' style={{backgroundColor: '#51afd8'}}>
            Xero
          </span>
        )}
        {invoice.state === 'draft' ? (
          <span className='tag is-dark is-small'>Draft</span>
        ) : invoice.isSent ? (
          <span className='tag is-success is-small'>Issued</span>
        ) : invoice.isSendable ? (
          <span className='tag is-success is-light is-small'>Send</span>
        ) : null}
      </td>
      <td>
        <span className='mr-2'>{invoice.invoiceNumber}</span>
        <sub className='has-text-weight-semibold' style={{whiteSpace: 'pre-line'}}>
          {invoice.description}
        </sub>
      </td>
      <td>{formatDate(invoice.dueDate)}</td>
      <td className='has-text-right'>
        <span>{invoice.amount < 0 ? formatNumber(Math.abs(invoice.amount)) : null}</span>
      </td>
      <td className='has-text-right'>
        <span className='has-text-success'>{invoice.amount >= 0 ? formatNumber(invoice.amount) : null}</span>
      </td>
      <td className='has-text-right'>
        {invoice.state !== 'draft' && <span>{formatNumber(invoice.balance, {accounting: true})}</span>}
      </td>
    </tr>
  )
}

const TransactionRow = ({transaction, onClick}) => {
  const rowStyle = {}
  if (transaction.state === 'draft') rowStyle.opacity = '25%'
  return (
    <tr onClick={onClick} style={rowStyle}>
      <td>{formatDate(transaction.dateSettled)}</td>
      <td>
        {transaction.xeroLink && (
          <span className='tag is-small has-text-white' style={{backgroundColor: '#51afd8'}}>
            Xero
          </span>
        )}
      </td>
      <td>
        <span className='mr-2'>{transaction.description}</span>
        {transaction.dateSettled != transaction.date ? (
          <sub className='has-text-weight-semibold' style={{whiteSpace: 'pre-line'}}>
            Received {formatDate(transaction.date)}
          </sub>
        ) : null}
      </td>
      <td></td>
      <td className='has-text-right'>
        {transaction.__typename === 'Debit' ? formatNumber(Math.abs(transaction.amount)) : null}
      </td>
      <td className='has-text-right'>
        <span className='has-text-success'>
          {['Credit', 'Payment'].includes(transaction.__typename) ? formatNumber(transaction.amount) : null}
        </span>
      </td>
      <td className='has-text-right'>
        {transaction.state == 'draft' ? (
          <span className='tag is-dark is-small'>Pending</span>
        ) : (
          <span>{formatNumber(transaction.balance, {accounting: true})}</span>
        )}
      </td>
    </tr>
  )
}

export default ({statement}) => {
  const history = useHistory()
  const {organisationID, accountID} = useParams()
  const {pushModal} = useModal()

  return (
    <table className='table is-striped is-hoverable is-fullwidth is-linked past'>
      <colgroup>
        <col width='15%' />
        <col width='6%' />
        <col width='30%' />
        <col width='15%' />
        <col width='10.67%' />
        <col width='10.67%' />
        <col width='12.67%' />
      </colgroup>
      <thead>
        <tr className='is-size-8'>
          <th>Date settled</th>
          <th></th>
          <th></th>
          <th>Due Date</th>
          <th className='has-text-right'>Debit</th>
          <th className='has-text-right'>Credit</th>
          <th className='has-text-right'>Balance</th>
        </tr>
      </thead>
      <tbody>
        {statement.map((transaction, i) =>
          transaction.__typename === 'Invoice' ? (
            <InvoiceRow
              key={i}
              invoice={transaction}
              onClick={() => history.push(`/orgs/${organisationID}/invoices/${transaction.id}`)}
            />
          ) : (
            <TransactionRow
              key={i}
              transaction={transaction}
              onClick={() => {
                transaction.__typename === 'Credit'
                  ? pushModal('credit', {accountId: accountID, creditId: transaction.id})
                  : transaction.__typename === 'Debit'
                    ? pushModal('debit', {accountId: accountID, debitId: transaction.id})
                    : pushModal('payment', {accountId: accountID, paymentId: transaction.id})
              }}
            />
          )
        )}
      </tbody>
    </table>
  )
}
